import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiButton } from 'ui-components';

export const StyledAddFilterButton = styled(UiButton)(
  ({ theme }) => css`
    background-color: ${theme.palette.accent.oceanBlue};
    margin: 0 8px;
    height: 44px;
    white-space: 'nowrap';
    flex-shrink: 0;

    &:hover {
      background-color: ${theme.palette.accent.oceanBlue};
    }
  `
);
